module.exports = __webpack_public_path__ + "assets/img/React.e6e1bd4d.png";